module.exports = __webpack_public_path__ + "images/home/orientation/feedback.f60abbf7cb5745c0b532.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/home/orientation/feedback.svg
// module id = Adqr
// module chunks = 13